import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPages } from './services/wordpressService';

const NavBar = () => {
  const [pages, setPages] = useState([]);

  useEffect(() => {
    const fetchPages = async () => {
      const data = await getPages();
      setPages(data);
    };
    fetchPages();
  }, []);

  return (
    <nav className="bg-gray-800 text-white p-4">
      <div className="container mx-auto">
        <h2>Hello</h2>
        <ul className="flex space-x-4">
          {pages.map(page => (
            <li key={page.id}>
              <Link to={`/page/${page.id}`} className="hover:underline">
                {page.title.rendered}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default NavBar;
